import { defineCustomElement } from "vue";
import VCBannerInsightIA from "./VCBannerInsightIA.ce.vue";
import { Register } from "@/ui/vue-components/components";

const _register: Register = {
  register() {
    if (!customElements.get("vc-banner-insight-ia")) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const CustomElement = defineCustomElement(VCBannerInsightIA as any);
      customElements.define("vc-banner-insight-ia", CustomElement);
    }
  }
};

export default _register;
